import React, { useContext } from "react"
import * as styles from "./Styles/PC.module.scss"
import classNames from "classnames"
import { AreaContext } from "../../Common/FilterConditionsContext"
import Loader from "../../Common/Loader"

const AreaList = (props) => {
  const areas = useContext(AreaContext)

  return (
    <React.Fragment>
      <h2 className={classNames("p-top-section__header", "pc")}>
        エリアからお店・施設をさがす
      </h2>
      <div>
        <Loader show={areas.length == 0} color="green" small={false} />
        {areas.map((region, i) => (
          <div className={styles.regions} key={i}>
            <div className={styles.region}>{region.name}</div>
            <div className={styles.prefectures}>
              {region.prefectures.map((pref, j) => (
                <div key={j}>
                  <a href={pref.path}>{pref.name}</a>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  )
}
export default AreaList
